<div class="container-fluid">
    <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>


    <section *ngIf="billList && billList.length>0">

        <div class="row">
            <div class="col-lg-9">
                @if(billGenerationType =='Combined'){
                <accordion [closeOthers]="false" class="accordion custom-accordian-bill" [isAnimated]="true">
                    <div *ngFor="let bills of billList; let i = index">
                        <accordion-group [isOpen]="isAllOpen" class="accordion-item mb-3 panel-open" #item5>
                            <div accordion-heading class="d-flex flex-grow-1">
                                <div class="d-flex pt-2 ">
                                    <div class="form-check">
                                        <input class="form-check-input"
                                            (click)="onCheckboxClick($event, bills?.isChecked, i, bills?.billNo)"
                                            (change)="checkValue(bills?.isChecked,i,bills?.billNo)"
                                            [disabled]="bills.isdisabled" [(ngModel)]="bills.isChecked" type="checkbox"
                                            id="formCheck1">
                                    </div>
                                </div>

                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                        <div class="flex-grow-1">
                                            <img class="utility-img" src="../../../../assets/images/brands/group.png">
                                            <span class="text-primary font-size-16">Bill Details ({{bills?.utility}})

                                            </span>
                                        </div>

                                    </div>


                                    <div class="row mx-2 mt-3 text-accordian">
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Bill Date</label>
                                                <p>{{bills?.billGeneratedDate!=null?
                                                    (bills?.billGeneratedDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Due Date</label>
                                                <p>{{bills?.dueDate!=null?
                                                    (bills?.dueDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Total Bill </label>
                                                <p>
                                                    {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                                    | currency: 'INR': 'symbol') : '0'}}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-lg-3  mb-3">
                                            <div class=" mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="mdi font-size-24"
                                        [ngClass]="!item5?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-center">
                                        <img src="../../../../assets/images/brands/utility.png" class="me-2 w-3">
                                        <p class="text-decoration-underline card-title font-size-16">Consumer
                                            Details</p>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/user.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Consumer Name</label>
                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/bill.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Bill No.</label>
                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>

                            <!-- gas -->


                            <div *ngIf="bills?.gas.length>0">
                                <div class="row" *ngFor="let gas of bills?.gas let i=index">

                                    <div class="row" *ngIf="bills?.gas.length>0">
                                        <div class="d-flex custom-list-bill w-100 align-items-center p-2 mt-3">
                                            <img src="../../../../assets/images/brands/gas.png">
                                            <span class="font-weight-bold ms-3 font-size-15">Gas Details : (Meter No :{{
                                                bills.gas[i].deviceSrno}})</span>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" pt-2 ">

                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Reading Date</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">{{gas?.previousReadingDate!=null?
                                                            (gas?.previousReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>


                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Reading Date</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">{{gas?.currentReadingDate!=null?
                                                            (gas?.currentReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>


                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{gas?.previousMeterReading!=undefined?gas.previousMeterReading
                                                            +' '+'m³' :'-'}}

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{gas?.currentMeterReading!=undefined?gas.currentMeterReading
                                                            +' '+'m³':'-'}}

                                                        </p>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class="pt-2 "></div>
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Units Consumed</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{gas?.noofUnitsConsumed?gas.noofUnitsConsumed +' m³':'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1 ">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{gas?.unitRate!=undefined?(gas.unitRate
                                                            | currency: 'INR': 'symbol') : '0'}}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1 ">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Amount</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{gas?.billAmount!=undefined?(gas.billAmount
                                                            | currency: 'INR': 'symbol') : '0'}}
                                                        </p>

                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>

                                    <div class="row" *ngIf="gas.otherCharges.length>0">
                                        <table class="table custom-border-table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Service Name</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">GST (%)</th>
                                                    <th scope="col">GST Amount</th>
                                                    <th scope="col">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let charge of gas.otherCharges">
                                                    <td>{{charge.name}}</td>
                                                    <td>{{charge.amount |currency:'INR':true}}</td>
                                                    <td>{{charge.gst != '' ?charge.gst:'-'}}</td>
                                                    <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                    <td>{{charge.total |currency:'INR':true}}</td>

                                                </tr>
                                                <tr>
                                                    <th scope="row"></th>
                                                    <td colspan="1"></td>
                                                    <td></td>
                                                    <td class="font-weight-bolder">Total Amount</td>
                                                    <td class="font-weight-bolder">
                                                        {{bills.totalServiceCharge!=undefined?(bills.totalServiceCharge
                                                        | currency: 'INR': 'symbol') : '0'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>


                                    <div class="col-md-12">
                                        <div class="text-center totalBill ">
                                            <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                                {{gas.totalAmount!=undefined?(gas.totalAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- water -->

                            <div *ngIf="bills?.water.length>0">
                                <div class="row" *ngFor="let water of bills?.water let i=index">

                                    <div class="row" *ngIf="bills?.water.length>0">
                                        <div class="d-flex custom-list-bill w-100 align-items-center p-2 mt-3">
                                            <img src="../../../../assets/images/brands/water.png">
                                            <span class="font-weight-bold ms-3 font-size-15">Water Details :
                                                (Meter No :{{ bills?.water[i]?.deviceSrno}})</span>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" pt-2 ">

                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Reading Date</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end">{{water?.previousReadingDate!=null?
                                                            (water?.previousReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Reading Date</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">{{water?.currentReadingDate!=null?
                                                            (water?.currentReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{water?.previousMeterReading?water.previousMeterReading +' '+'L':'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{water?.currentMeterReading?water.currentMeterReading +' '+'L':'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class="pt-2 ">
                                            </div>
                                            <div class=" ">


                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Units Consumed</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{water?.noofUnitsConsumed?water.noofUnitsConsumed +'
                                                            L':'-'}}</p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{water?.unitRate!=undefined?(water.unitRate
                                                            | currency: 'INR': 'symbol') : '0'}}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Amount</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{water?.billAmount!=undefined?(water.billAmount
                                                            | currency: 'INR': 'symbol') : '0'}}
                                                        </p>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                    <div class="row" *ngIf="water.otherCharges.length>0">
                                        <table class="table custom-border-table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Service Name</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">GST (%)</th>
                                                    <th scope="col">GST Amount</th>
                                                    <th scope="col">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let charge of water.otherCharges">
                                                    <td>{{charge.name}}</td>
                                                    <td>{{charge.amount |currency:'INR':true}}</td>
                                                    <td>{{charge.gst != '' ?charge.gst:'-'}}</td>
                                                    <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                    <td>{{charge.total |currency:'INR':true}}</td>

                                                </tr>
                                                <tr>
                                                    <th scope="row"></th>
                                                    <td colspan="1"></td>
                                                    <td></td>
                                                    <td class="font-weight-bolder">Total Amount</td>
                                                    <td class="font-weight-bolder">
                                                        {{water.totalServiceCharge!=undefined?(water.totalServiceCharge
                                                        | currency: 'INR': 'symbol') : '0'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>


                                    <div class="col-md-12">
                                        <div class="text-center totalBill ">
                                            <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                                {{water?.totalAmount!=undefined?(water.totalAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- electricity -->

                            <div *ngIf="bills?.electricity.length>0">
                                <div *ngFor="let ele of bills?.electricity let i=index">
                                    <div class="row" *ngIf="bills?.electricity.length>0">
                                        <div class="d-flex custom-list-bill w-100 align-items-center p-2 mt-3">
                                            <img src="../../../../assets/images/brands/electricity.png">
                                            <span class="font-weight-bold ms-3 font-size-15">Electricity Details :
                                                (Meter No :
                                                {{bills?.electricity[i]?.deviceSrno}})</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">
                                                <div class=" pt-2 ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Meter Reading EB </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.electricityPreviousMeterReadingEB!=undefined?ele.electricityPreviousMeterReadingEB
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Meter Reading
                                                                DG</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.electricityPreviousMeterReadingDG
                                                                !=undefined?ele.electricityPreviousMeterReadingDG +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="">
                                                    <div class="d-flex  align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Meter Reading EB</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.electricityCurrentMeterReadingEB!=undefined?ele.electricityCurrentMeterReadingEB
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex  align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Meter Reading DG </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.electricityCurrentMeterReadingDG!=undefined?ele.electricityCurrentMeterReadingDG
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>


                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">

                                                <div class=" ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">No. Of Units Consumed EB</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.noofElectricityUnitsConsumedEB!=undefined?ele.noofElectricityUnitsConsumedEB
                                                                + ' kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label ">No. Of Units Consumed DG </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.noofElectricityUnitsConsumedDG!=undefined?ele.noofElectricityUnitsConsumedDG
                                                                + ' kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Unit Rate EB </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.unitRateEB!=undefined?(ele.unitRateEB
                                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                                            <!--  <p class="float-end">{{ele?.unitRateEB?ele.unitRateEB:'-'}}</p> -->
                                                        </div>
                                                    </div>

                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Unit Rate DG </label>
                                                        </div>
                                                        <div class="flex-grow-1">

                                                            <p class="float-end mb-0">
                                                                {{ele?.unitRateDG!=undefined?(ele.unitRateDG
                                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                                        </div>
                                                    </div>

                                                </div>


                                            </div>
                                        </div>


                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">
                                                <div class=" ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Reading Date
                                                            </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.previousReadingDate!=null?
                                                                (ele?.previousReadingDate | date:'d MMMM yyyy')
                                                                :'' }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Reading Date </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.currentReadingDate!=null?
                                                                (ele?.currentReadingDate | date:'d MMMM yyyy')
                                                                :'' }}
                                                            </p>
                                                        </div>
                                                    </div>


                                                </div>


                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">
                                                <div class=" ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Bill Amount</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.billAmount!=undefined?(ele.billAmount
                                                                | currency: 'INR': 'symbol') : '0'}}
                                                            </p>
                                                        </div>
                                                    </div>


                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="ele.otherCharges.length>0">
                                        <table class="table custom-border-table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Service Name</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">GST (%)</th>
                                                    <th scope="col">GST Amount</th>
                                                    <th scope="col">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let charge of ele.otherCharges">
                                                    <td>{{charge.name}}</td>
                                                    <td>{{charge.amount |currency:'INR':true}}</td>
                                                    <td>{{charge.gst != '' ?charge.gst:'-'}}</td>
                                                    <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                    <td>{{charge.total |currency:'INR':true}}</td>

                                                </tr>
                                                <tr>
                                                    <th scope="row"></th>
                                                    <td colspan="1"></td>
                                                    <td></td>
                                                    <td class="font-weight-bolder">Total Amount</td>
                                                    <td class="font-weight-bolder">
                                                        {{ele.totalServiceCharge!=undefined?(ele.totalServiceCharge
                                                        | currency: 'INR': 'symbol') : '0'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>


                                    <div class="col-md-12">
                                        <div class="text-center totalBill ">
                                            <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                                {{ele?.totalAmount!=undefined?(ele.totalAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--  trisource-->
                            <div *ngIf="bills?.triSource?.length>0">
                                <div *ngFor="let ele of bills?.triSource let i=index">
                                    <div class="row" *ngIf="bills?.triSource?.length>0">
                                        <div class="d-flex custom-list-bill w-100 align-items-center p-2 mt-3">
                                            <img src="../../../../assets/images/brands/electricity.png">
                                            <span class="font-weight-bold ms-3 font-size-15">Trisource Details :
                                                (Meter No :
                                                {{bills?.triSource[i]?.deviceSrno}})</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">
                                                <div class=" pt-2 ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Meter Reading EB </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.previousMeterReadingEB!=undefined?ele.previousMeterReadingEB
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Meter Reading
                                                                DG</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.previousMeterReadingDG
                                                                !=undefined?ele.previousMeterReadingDG +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Meter Reading
                                                                Solar</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.previousMeterReadingSolar
                                                                !=undefined?ele.previousMeterReadingSolar +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="">
                                                    <div class="d-flex  align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Meter Reading EB</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.currentMeterReadingEB!=undefined?ele.currentMeterReadingEB
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex  align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Meter Reading DG </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.currentMeterReadingDG!=undefined?ele.currentMeterReadingDG
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex  align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Meter Reading Solar
                                                            </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.currentMeterReadingSolar!=undefined?ele.currentMeterReadingSolar
                                                                +' '+'kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex  align-items-center mb-1"
                                                        *ngIf="triSourceBillingMethodology=='Carry Forward'">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Effective EB Units
                                                            </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.actualEbBillUnits!=undefined?ele.actualEbBillUnits
                                                                +' kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>


                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">

                                                <div class=" ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">No. Of Units Consumed EB</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.noofElectricityUnitsConsumedEB!=undefined?ele.noofElectricityUnitsConsumedEB
                                                                + ' kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label ">No. Of Units Consumed DG </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.noofElectricityUnitsConsumedDG!=undefined?ele.noofElectricityUnitsConsumedDG
                                                                + ' kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label ">No. Of Units Consumed Solar
                                                            </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.NoofUnitsConsumedSolar!=undefined?ele.NoofUnitsConsumedSolar
                                                                + ' kWh':'-'}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Unit Rate EB </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.unitRateEB!=undefined?(ele.unitRateEB
                                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                                            <!--  <p class="float-end">{{ele?.unitRateEB?ele.unitRateEB:'-'}}</p> -->
                                                        </div>
                                                    </div>

                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Unit Rate DG </label>
                                                        </div>
                                                        <div class="flex-grow-1">

                                                            <p class="float-end mb-0">
                                                                {{ele?.unitRateDG!=undefined?(ele.unitRateDG
                                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Unit Rate Solar </label>
                                                        </div>
                                                        <div class="flex-grow-1">

                                                            <p class="float-end mb-0">
                                                                {{ele?.UnitRateSolar!=undefined?(ele.UnitRateSolar
                                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                                        </div>
                                                    </div>

                                                </div>


                                            </div>
                                        </div>


                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">
                                                <div class=" ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Previous Reading Date
                                                            </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.previousReadingDate!=null?
                                                                (ele?.previousReadingDate | date:'d MMMM yyyy')
                                                                :'' }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Current Reading Date </label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.currentReadingDate!=null?
                                                                (ele?.currentReadingDate | date:'d MMMM yyyy')
                                                                :'' }}
                                                            </p>
                                                        </div>
                                                    </div>


                                                </div>


                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="custom-list-bill-view p-2 rounded mt-2">
                                                <div class=" ">
                                                    <div class="d-flex align-items-center mb-1">
                                                        <div class="flex-grow-1 me-1">
                                                            <label class="form-label">Bill Amount</label>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <p class="float-end mb-0">
                                                                {{ele?.billAmount!=undefined?(ele.billAmount
                                                                | currency: 'INR': 'symbol') : '0'}}
                                                            </p>
                                                        </div>
                                                    </div>


                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="ele.otherCharges.length>0">
                                        <table class="table custom-border-table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Service Name</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">GST (%)</th>
                                                    <th scope="col">GST Amount</th>
                                                    <th scope="col">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let charge of ele.otherCharges">
                                                    <td>{{charge.name}}</td>
                                                    <td>{{charge.amount |currency:'INR':true}}</td>
                                                    <td>{{charge.gst != '' ?charge.gst:'-'}}</td>
                                                    <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                    <td>{{charge.total |currency:'INR':true}}</td>

                                                </tr>
                                                <tr>
                                                    <th scope="row"></th>
                                                    <td colspan="1"></td>
                                                    <td></td>
                                                    <td class="font-weight-bolder">Total Amount</td>
                                                    <td class="font-weight-bolder">
                                                        {{ele.totalServiceCharge!=undefined?(ele.totalServiceCharge
                                                        | currency: 'INR': 'symbol') : '0'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>


                                    <div class="col-md-12">
                                        <div class="text-center totalBill ">
                                            <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                                {{ele?.totalAmount!=undefined?(ele.totalAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- general Charges Charges -->
                            <div class="row" *ngIf="bills?.generalCharges.length>0">
                                <div class="d-flex custom-list-bill w-100 align-items-center p-2 mt-3">
                                    <img src="../../../../assets/images/brands/rupee.png">
                                    <span class="font-weight-bold ms-3 font-size-15">Other Charges </span>
                                </div>
                            </div>
                            <div>
                                <div class="row" *ngIf="bills?.generalCharges.length>0">
                                    <table class="table custom-border-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Service Name</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">GST (%)</th>
                                                <th scope="col">GST Amount</th>
                                                <th scope="col">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of bills.generalCharges">
                                                <td>{{charge.name}}</td>
                                                <td>{{charge.amount |currency:'INR':true}}</td>
                                                <td>{{charge.gst != '' ?charge.gst:'-'}}</td>
                                                <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                <td>{{charge.total |currency:'INR':true}}</td>

                                            </tr>
                                            <tr>
                                                <th scope="row"></th>
                                                <td colspan="1"></td>
                                                <td></td>
                                                <td class="font-weight-bolder">Total Amount</td>
                                                <td class="font-weight-bolder">
                                                    {{bills.totalGeneralCharge!=undefined?(bills.totalGeneralCharge
                                                    | currency: 'INR': 'symbol') : '0'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>


                                    <div class="col-md-12">
                                        <div class="text-center totalBill ">
                                            <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                                {{bills.totalGeneralCharge!=undefined?(bills.totalGeneralCharge
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 ">
                                    <div class="d-flex justify-content-around penaltyBill">
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.totalUtilityAmount!=undefined?(bills.totalUtilityAmount
                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                        </div>
                                        <div class="text-center" *ngIf="bills.dueAmount>0">
                                            <p class="font-size-16 font-weight-bolder">Previous Month Due Amount
                                            </p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.dueAmount!=undefined?(bills.dueAmount
                                                | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Penalty Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.totalPenalty!=undefined?(bills?.totalPenalty
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Total Bill Amount</p>
                                            <!--  <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                            {{bills?(bills.totalGeneralCharge+bills.billAmount+bills?.totalPenalty
                                            | currency: 'INR': 'symbol') : '0'}} </p> -->
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <div (click)="onViewClick(billList[i])" style="cursor: pointer;">
                                    <p style="color: #2387C8;">Unpaid Bills View Details</p>
                                </div>
                            </div>

                        </accordion-group>
                    </div>



                </accordion>
                }@else {
                <!-- individual Bills  -->
                <accordion [closeOthers]="false" class="accordion custom-accordian-bill" [isAnimated]="true">
                    <div *ngFor="let bills of billList; let i = index">
                        <!-- Gas -->

                        @if(bills?.gas.length>0){
                        <accordion-group [isOpen]="isAllOpen" *ngFor="let gas of bills?.gas;let i = index"
                            class="accordion-item mb-3 panel-open" #item2>

                            <div accordion-heading class="d-flex flex-grow-1">

                                <div class="d-flex pt-2 ">
                                    <div class="form-check ">
                                        <input class="form-check-input"
                                            (click)="onCheckboxClick($event, bills?.isChecked, i, bills?.billNo)"
                                            [disabled]="bills.isdisabled"
                                            (change)="checkValue(bills?.isChecked,i,bills?.billNo)"
                                            [(ngModel)]="bills.isChecked" type="checkbox" id="formCheck1">
                                    </div>
                                </div>
                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                        <div class="flex-grow-1">
                                            <img class="utility-img" src="../../../../assets/images/brands/gas.png">
                                            <span class="text-primary font-size-15">
                                                Gas Details : (Meter No :{{gas.deviceSrno}})
                                            </span>
                                        </div>

                                    </div>


                                    <div class="row mx-2 mt-3 text-accordian">
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Bill Date</label>
                                                <p>{{bills?.billGeneratedDate!=null?
                                                    (bills?.billGeneratedDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Due Date</label>
                                                <p>{{bills?.dueDate!=null?
                                                    (bills?.dueDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Units Consumed</label>
                                                <p>{{gas?.noofUnitsConsumed!=undefined?gas.noofUnitsConsumed +'
                                                    m³':'-'}}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="mdi font-size-24"
                                        [ngClass]="!item2?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                </div>


                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-center">
                                        <img src="../../../../assets/images/brands/utility.png" class="me-2 w-3">
                                        <p class="text-decoration-underline card-title font-size-15">Consumer
                                            Details
                                        </p>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/user.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Consumer Name</label>
                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
 -->
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/bill.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Bill No.</label>
                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>


                            <div class="row">

                                <div class="col-md-6">
                                    <div class="custom-list-bill-view p-2 rounded mt-2">
                                        <div class=" pt-2 ">

                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Previous Reading Date</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">{{gas?.previousReadingDate!=null?
                                                        (gas?.previousReadingDate | date:'d MMMM yyyy')
                                                        :'' }}
                                                    </p>


                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Current Reading Date</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">{{gas?.currentReadingDate!=null?
                                                        (gas?.currentReadingDate | date:'d MMMM yyyy')
                                                        :'' }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Previous Meter Reading</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{gas?.previousMeterReading!=undefined?gas.previousMeterReading
                                                        +' '+'m³'
                                                        :'-'}}</p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Current Meter Reading</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{gas?.currentMeterReading
                                                        !=undefined?gas.currentMeterReading +' '+'m³':'-'}}
                                                    </p>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="custom-list-bill-view p-2 rounded mt-2">
                                        <div class="pt-2 "></div>
                                        <div class=" ">
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Unit Consumed</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{gas?.noofUnitsConsumed!=undefined?gas.noofUnitsConsumed +'
                                                        m³':'-'}}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Unit Rate</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{gas?.unitRate!=undefined?(gas.unitRate
                                                        | currency: 'INR': 'symbol') : '0'}}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Amount</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{gas.billAmount!=undefined?(gas.billAmount
                                                        | currency: 'INR': 'symbol') : '0'}}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                </div>
                                <div class="row" *ngIf="gas.otherCharges.length>0">
                                    <table class="table custom-border-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Service Name</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">GST (%)</th>
                                                <th scope="col">GST Amount</th>
                                                <th scope="col">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of gas.otherCharges">
                                                <td>{{charge.name}}</td>
                                                <td>{{charge.amount |currency:'INR':true}}</td>
                                                <td>{{charge.gst != '' ?charge.gst:'-'}}</td>
                                                <td>{{charge.gstAmt!= undefined ? (charge.gstAmt
                                                    |currency:'INR':true):'-'}}</td>
                                                <td>{{charge.total |currency:'INR':true}}</td>

                                            </tr>
                                            <tr>
                                                <th scope="row"></th>
                                                <td colspan="1"></td>
                                                <td></td>
                                                <td class="font-weight-bolder">Total Amount</td>
                                                <td class="font-weight-bolder">
                                                    {{gas.totalServiceCharge!=undefined?(gas.totalServiceCharge
                                                    | currency: 'INR': 'symbol') : '0'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12">
                                    <div class="text-center totalBill ">
                                        <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                            {{gas.totalAmount!=undefined?(gas.totalAmount
                                            | currency: 'INR': 'symbol') : '0'}} </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 ">
                                <div class="d-flex justify-content-around penaltyBill">
                                    <!--  <div class="text-center">
                                        <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                        <p class="font-size-18 font-weight-bold">
                                            {{bills?.totalAmountwithoutpenalty!=undefined?(bills.totalAmountwithoutpenalty
                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                    </div> -->
                                    <div class="text-center" *ngIf="bills.dueAmount>0">
                                        <p class="font-size-16 font-weight-bolder">Previous Month Due Amount
                                        </p>
                                        <p class="font-size-18 font-weight-bold">
                                            {{bills?.dueAmount!=undefined?(bills.dueAmount
                                            | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                    </div>
                                    <div class="text-center">
                                        <p class="font-size-16 font-weight-bolder">Penalty Amount</p>
                                        <p class="font-size-18 font-weight-bold">
                                            {{gas?.penaltyAmount!=undefined?(gas?.penaltyAmount
                                            | currency: 'INR': 'symbol') : '0'}} </p>
                                    </div>
                                    <div class="text-center">
                                        <p class="font-size-16 font-weight-bolder">Total Bill Amount</p>
                                        <!-- <p class="font-size-18 font-weight-bold"> {{ ((bills?.totalBillAmount ?? 0)
                                            + (bills?.totalPenalty ?? 0)) | currency:
                                            'INR':true:'1.2-2' }}</p> -->
                                        <p class="font-size-18 font-weight-bold">
                                            {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <div (click)="onViewClick(billList[i])" style="cursor: pointer;">
                                    <p style="color: #2387C8;">Unpaid Bills View Details</p>
                                </div>
                            </div>
                        </accordion-group>
                        }

                        <!--  Water bill  -->

                        @if(bills?.water.length>0){
                        <accordion-group [isOpen]="isAllOpen" *ngFor="let water of bills?.water;let i=index"
                            class="accordion-item mb-3 panel-open" #item2>

                            <div accordion-heading class="d-flex flex-grow-1">

                                <div class="d-flex pt-2 ">
                                    <div class="form-check  ">
                                        <input class="form-check-input"
                                            (click)="onCheckboxClick($event, bills?.isChecked, i, bills?.billNo)"
                                            (change)="checkValue(bills?.isChecked,i,bills?.billNo)"
                                            [disabled]="bills.isdisabled" [(ngModel)]="bills.isChecked" type="checkbox"
                                            id="formCheck1">
                                    </div>
                                </div>
                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                        <div class="flex-grow-1">
                                            <img class="utility-img" src="../../../../assets/images/brands/water.png">
                                            <span class="text-primary font-size-15">
                                                Water Details : (Meter No :{{water.deviceSrno}})
                                            </span>
                                        </div>

                                    </div>


                                    <div class="row mx-2 mt-3 text-accordian">
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Bill Date</label>
                                                <p>{{bills?.billGeneratedDate!=null?
                                                    (bills?.billGeneratedDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Due Date</label>
                                                <p>{{bills?.dueDate!=null?
                                                    (bills?.dueDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Units Consumed</label>
                                                <p>{{water?.noofUnitsConsumed!=undefined?water.noofUnitsConsumed+'
                                                    L':'-'}}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="mdi font-size-24"
                                        [ngClass]="!item2?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                </div>


                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-center">
                                        <img src="../../../../assets/images/brands/utility.png" class="me-2 w-3">
                                        <p class="text-decoration-underline card-title font-size-15">Consumer
                                            Details
                                        </p>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/user.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Consumer Name</label>
                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/bill.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Bill No.</label>
                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-6">
                                    <div class="custom-list-bill-view p-2 rounded mt-2">
                                        <div class=" pt-2 ">

                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Previous Reading Date</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end">{{water?.previousReadingDate!=null?
                                                        (water?.previousReadingDate | date:'d MMMM yyyy')
                                                        :'' }}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Current Reading Date</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">{{water?.currentReadingDate!=null?
                                                        (water?.currentReadingDate | date:'d MMMM yyyy')
                                                        :'' }}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Previous Meter Reading</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{water?.previousMeterReading!=undefined?water.previousMeterReading
                                                        +' '+'L':'-'}}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Current Meter Reading</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{water?.currentMeterReading!=undefined?water.currentMeterReading
                                                        +' '+'L':'-'}}
                                                    </p>

                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="custom-list-bill-view p-2 rounded mt-2">
                                        <div class="pt-2 ">
                                        </div>
                                        <div class=" ">
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Units Consumed</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{water?.noofUnitsConsumed!=undefined?water.noofUnitsConsumed+'
                                                        L':'-'}}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1 mb-2 pb-5">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Unit Rate</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{water?.unitRate!=undefined?(water.unitRate
                                                        | currency: 'INR': 'symbol') : '0'}}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mb-1">
                                                <div class="flex-grow-1 me-1">
                                                    <label class="form-label">Amount</label>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <p class="float-end mb-0">
                                                        {{water?.billAmount!=undefined?(water.billAmount
                                                        | currency: 'INR': 'symbol') : '0'}}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="row" *ngIf="water.otherCharges.length>0">
                                    <table class="table custom-border-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Service Name</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">GST (%)</th>
                                                <th scope="col">GST Amount</th>
                                                <th scope="col">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of water.otherCharges">
                                                <td>{{charge.name}}</td>
                                                <td>{{charge.amount |currency:'INR':true}}</td>
                                                <td>{{charge.gst !='' ?charge.gst : '-'}}</td>
                                                <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                <td>{{charge.total |currency:'INR':true}}</td>

                                            </tr>
                                            <tr>
                                                <th scope="row"></th>
                                                <td colspan="1"></td>
                                                <td></td>
                                                <td class="font-weight-bolder">Total Amount</td>
                                                <td class="font-weight-bolder">
                                                    {{water.totalServiceCharge!=undefined?(water.totalGeneralCharge
                                                    | currency: 'INR': 'symbol') : '0'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>


                                <div class="col-md-12">
                                    <div class="text-center totalBill ">
                                        <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                            {{water?.totalAmount!=undefined?(water.totalAmount
                                            | currency: 'INR': 'symbol') : '0'}} </p>
                                    </div>
                                </div>


                                <div class="col-md-12 ">
                                    <div class="d-flex justify-content-around penaltyBill">
                                        <!-- <div class="text-center">
                                                <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                                <p class="font-size-18 font-weight-bold">
                                                    {{bills?.totalAmountwithoutpenalty!=undefined?(totalAmountwithoutpenalty
                                                    | currency: 'INR': 'symbol') : '0'}}</p>
                                            </div> -->
                                        <div class="text-center" *ngIf="bills.dueAmount>0">
                                            <p class="font-size-16 font-weight-bolder">Previous Month Due Amount
                                            </p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.dueAmount!=undefined?(bills.dueAmount
                                                | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Penalty Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{water?.penaltyAmount!=undefined?(water?.penaltyAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Total Bill Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <div (click)="onViewClick(billList[i])" style="cursor: pointer;">
                                    <p style="color: #2387C8;">Unpaid Bills View Details</p>
                                </div>
                            </div>



                        </accordion-group>

                        }
                        <!--  Electricity bill  -->
                        @if(bills?.electricity.length>0){
                        <accordion-group [isOpen]="isAllOpen" *ngFor="let electricity of bills?.electricity;let i=index"
                            class="accordion-item mb-3 panel-open" #item3>

                            <div accordion-heading class="d-flex flex-grow-1">

                                <div class="d-flex pt-2 ">
                                    <div class="form-check  ">
                                        <input class="form-check-input"
                                            (click)="onCheckboxClick($event, bills?.isChecked, i, bills?.billNo)"
                                            (change)="checkValue(bills?.isChecked,i,bills?.billNo)"
                                            [disabled]="bills.isdisabled" [(ngModel)]="bills.isChecked" type="checkbox"
                                            id="formCheck1">
                                    </div>
                                </div>
                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                        <div class="flex-grow-1">
                                            <img class="utility-img"
                                                src="../../../../assets/images/brands/electricity.png">
                                            <span class="text-primary font-size-15">
                                                Electricity Details : (Meter No
                                                :{{electricity?.deviceSrno}})
                                            </span>
                                        </div>

                                    </div>


                                    <div class="row mx-2 mt-3 text-accordian">
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Bill Date</label>
                                                <p>{{bills?.billGeneratedDate!=null?
                                                    (bills?.billGeneratedDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Due Date</label>
                                                <p>{{bills?.dueDate!=null?
                                                    (bills?.dueDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Units Consumed (DG/EB)</label>
                                                <p>{{electricity?.noofElectricityUnitsConsumedEB?electricity.noofElectricityUnitsConsumedDG+
                                                    '
                                                    KW':'-'}}/{{electricity?.noofElectricityUnitsConsumedEB?electricity.noofElectricityUnitsConsumedEB
                                                    + ' KW':'-'}}
                                                </p>

                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-lg-3  mb-3">
                                                <div class="mb-3">
                                                    <label class="form-label">Subtotal</label>

                                                    <p>
                                                        {{bills?.billAmount!=undefined?(bills.billAmount
                                                        | currency: 'INR': 'symbol') : '0'}}
                                                    </p>
                                                </div>
                                            </div> -->
                                    </div>



                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="mdi font-size-24"
                                        [ngClass]="!item3?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-center">
                                        <img src="../../../../assets/images/brands/utility.png" class="me-2 w-3">
                                        <p class="text-decoration-underline card-title font-size-15">Consumer
                                            Details
                                        </p>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/user.png"
                                                            class="w-80">
                                                    </div>

                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Consumer Name</label>
                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/bill.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Bill No.</label>
                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" pt-2 ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading EB
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.electricityPreviousMeterReadingEB!=undefined?electricity.electricityPreviousMeterReadingEB
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading
                                                            DG</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.electricityPreviousMeterReadingDG
                                                            !=undefined?electricity.electricityPreviousMeterReadingDG +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="">
                                                <div class="d-flex  align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading
                                                            EB</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.electricityCurrentMeterReadingEB!=undefined?electricity.electricityCurrentMeterReadingEB
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex  align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading DG
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.electricityCurrentMeterReadingDG!=undefined?electricity.electricityCurrentMeterReadingDG
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">No.Of Units Consumed
                                                            EB</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.noofElectricityUnitsConsumedEB!=undefined?electricity.noofElectricityUnitsConsumedEB
                                                            + ' kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label ">No. Of Units Consumed DG
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.noofElectricityUnitsConsumedDG!=undefined?electricity.noofElectricityUnitsConsumedDG
                                                            + ' kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate EB </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.unitRateEB!=undefined?(electricity.unitRateEB
                                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                                        <!--  <p class="float-end">{{ele?.unitRateEB?ele.unitRateEB:'-'}}</p> -->
                                                    </div>
                                                </div>

                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate DG </label>
                                                    </div>
                                                    <div class="flex-grow-1">

                                                        <p class="float-end mb-0">
                                                            {{electricity?.unitRateDG!=undefined?(electricity.unitRateDG
                                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>


                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Reading Date</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.previousReadingDate!=null?
                                                            (electricity?.previousReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Reading Date </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.currentReadingDate!=null?
                                                            (electricity?.currentReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Bill Amount</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.billAmount!=undefined?(electricity.billAmount
                                                            | currency: 'INR': 'symbol') : '0'}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="electricity.otherCharges.length>0">
                                    <table class="table custom-border-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Service Name</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">GST (%)</th>
                                                <th scope="col">GST Amount</th>
                                                <th scope="col">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of electricity.otherCharges">
                                                <td>{{charge.name}}</td>
                                                <td>{{charge.amount |currency:'INR':true}}</td>
                                                <td>{{charge.gst !='' ?charge.gst : '-'}}</td>
                                                <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                <td>{{charge.total |currency:'INR':true}}</td>

                                            </tr>
                                            <tr>
                                                <th scope="row"></th>
                                                <td colspan="1"></td>
                                                <td></td>
                                                <td class="font-weight-bolder">Total Amount</td>
                                                <td class="font-weight-bolder">
                                                    {{electricity.totalServiceCharge!=undefined?(electricity.totalServiceCharge
                                                    | currency: 'INR': 'symbol') : '0'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>


                                <div class="col-md-12">
                                    <div class="text-center totalBill ">
                                        <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                            {{electricity?.totalAmount!=undefined?(electricity.totalAmount
                                            | currency: 'INR': 'symbol') : '0'}} </p>
                                    </div>
                                </div>

                                <div class="col-md-12 ">
                                    <div class="d-flex justify-content-around penaltyBill">
                                        <!-- <div class="text-center">
                                                <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                                <p class="font-size-18 font-weight-bold">
                                                    {{bills?.totalAmountwithoutpenalty!=undefined?(totalAmountwithoutpenalty
                                                    | currency: 'INR': 'symbol') : '0'}}</p>
                                            </div> -->
                                        <div class="text-center" *ngIf="bills.dueAmount>0">
                                            <p class="font-size-16 font-weight-bolder">Previous Month Due Amount
                                            </p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.dueAmount!=undefined?(bills.dueAmount
                                                | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Penalty Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{electricity?.penaltyAmount!=undefined?(electricity?.penaltyAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Total Bill Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <div (click)="onViewClick(billList[i])" style="cursor: pointer;">
                                    <p style="color: #2387C8;">Unpaid Bills View Details</p>
                                </div>
                            </div>

                        </accordion-group>
                        }

                        <!-- Tri Sources -->

                        @if(bills?.triSource?.length>0){
                        <accordion-group [isOpen]="isAllOpen" *ngFor="let electricity of bills?.triSource;let i=index"
                            class="accordion-item mb-3 panel-open" #item3>

                            <div accordion-heading class="d-flex flex-grow-1">

                                <div class="d-flex pt-2 ">
                                    <div class="form-check  ">
                                        <input class="form-check-input"
                                            (click)="onCheckboxClick($event, bills?.isChecked, i, bills?.billNo)"
                                            (change)="checkValue(bills?.isChecked,i,bills?.billNo)"
                                            [disabled]="bills.isdisabled" [(ngModel)]="bills.isChecked" type="checkbox"
                                            id="formCheck1">
                                    </div>
                                </div>
                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                        <div class="flex-grow-1">
                                            <img class="utility-img"
                                                src="../../../../assets/images/brands/electricity.png">
                                            <span class="text-primary font-size-15">
                                                Trisource Details : (Meter No
                                                :{{electricity?.deviceSrno}})
                                            </span>
                                        </div>

                                    </div>


                                    <div class="row mx-2 mt-3 text-accordian">
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Bill Date</label>
                                                <p>{{bills?.billGeneratedDate!=null?
                                                    (bills?.billGeneratedDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Due Date</label>
                                                <p>{{bills?.dueDate!=null?
                                                    (bills?.dueDate | date:'d MMMM yyyy')
                                                    :'' }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <label class="form-label">Units Consumed (DG/EB)</label>
                                                <p>{{electricity?.noofElectricityUnitsConsumedEB?electricity.noofElectricityUnitsConsumedDG+
                                                    '
                                                    KW':'-'}}/{{electricity?.noofElectricityUnitsConsumedEB?electricity.noofElectricityUnitsConsumedEB
                                                    + ' KW':'-'}}
                                                </p>

                                            </div>
                                        </div>
                                        <div class="col-lg-3  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="mdi font-size-24"
                                        [ngClass]="!item3?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-center">
                                        <img src="../../../../assets/images/brands/utility.png" class="me-2 w-3">
                                        <p class="text-decoration-underline card-title font-size-15">Consumer
                                            Details
                                        </p>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/user.png"
                                                            class="w-80">
                                                    </div>

                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Consumer Name</label>
                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/bill.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Bill No.</label>
                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" pt-2 ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading EB
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.previousMeterReadingEB!=undefined?electricity.previousMeterReadingEB
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading
                                                            DG</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.previousMeterReadingDG
                                                            !=undefined?electricity.previousMeterReadingDG +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Meter Reading
                                                            Solar</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.previousMeterReadingSolar
                                                            !=undefined?electricity.previousMeterReadingSolar +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="">
                                                <div class="d-flex  align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading
                                                            EB</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.currentMeterReadingEB!=undefined?electricity.currentMeterReadingEB
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex  align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading DG
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.currentMeterReadingDG!=undefined?electricity.currentMeterReadingDG
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex  align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Meter Reading Solar
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.currentMeterReadingSolar!=undefined?electricity.currentMeterReadingSolar
                                                            +' '+'kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex  align-items-center mb-1"
                                                    *ngIf="triSourceBillingMethodology=='Carry Forward'">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Effective EB Units
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.actualEbBillUnits!=undefined?electricity.actualEbBillUnits
                                                            +' kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">No.Of Units Consumed
                                                            EB</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.noofElectricityUnitsConsumedEB!=undefined?electricity.noofElectricityUnitsConsumedEB
                                                            + ' kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label ">No. Of Units Consumed DG
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.noofElectricityUnitsConsumedDG!=undefined?electricity.noofElectricityUnitsConsumedDG
                                                            + ' kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label ">No. Of Units Consumed Solar
                                                        </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.NoofUnitsConsumedSolar!=undefined?electricity.NoofUnitsConsumedSolar
                                                            + ' kWh':'-'}}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate EB </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.unitRateEB!=undefined?(electricity.unitRateEB
                                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                                        <!--  <p class="float-end">{{ele?.unitRateEB?ele.unitRateEB:'-'}}</p> -->
                                                    </div>
                                                </div>

                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate DG </label>
                                                    </div>
                                                    <div class="flex-grow-1">

                                                        <p class="float-end mb-0">
                                                            {{electricity?.unitRateDG!=undefined?(electricity.unitRateDG
                                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Unit Rate Solar </label>
                                                    </div>
                                                    <div class="flex-grow-1">

                                                        <p class="float-end mb-0">
                                                            {{electricity?.UnitRateSolar!=undefined?(electricity.UnitRateSolar
                                                            | currency: 'INR': 'symbol') : '0'}}</p>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>


                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Previous Reading Date</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.previousReadingDate!=null?
                                                            (electricity?.previousReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Current Reading Date </label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.currentReadingDate!=null?
                                                            (electricity?.currentReadingDate | date:'d MMMM yyyy')
                                                            :'' }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="custom-list-bill-view p-2 rounded mt-2">
                                            <div class=" ">
                                                <div class="d-flex align-items-center mb-1">
                                                    <div class="flex-grow-1 me-1">
                                                        <label class="form-label">Bill Amount</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <p class="float-end mb-0">
                                                            {{electricity?.billAmount!=undefined?(electricity.billAmount
                                                            | currency: 'INR': 'symbol') : '0'}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="electricity.otherCharges.length>0">
                                    <table class="table custom-border-table">
                                        <thead>
                                            <tr>
                                                <th scope="col">Service Name</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">GST (%)</th>
                                                <th scope="col">GST Amount</th>
                                                <th scope="col">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let charge of electricity.otherCharges">
                                                <td>{{charge.name}}</td>
                                                <td>{{charge.amount |currency:'INR':true}}</td>
                                                <td>{{charge.gst !='' ?charge.gst : '-'}}</td>
                                                <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                <td>{{charge.total |currency:'INR':true}}</td>

                                            </tr>
                                            <tr>
                                                <th scope="row"></th>
                                                <td colspan="1"></td>
                                                <td></td>
                                                <td class="font-weight-bolder">Total Amount</td>
                                                <td class="font-weight-bolder">
                                                    {{electricity.totalServiceCharge!=undefined?(electricity.totalServiceCharge
                                                    | currency: 'INR': 'symbol') : '0'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>


                                <div class="col-md-12">
                                    <div class="text-center totalBill ">
                                        <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                            {{electricity?.totalAmount!=undefined?(electricity.totalAmount
                                            | currency: 'INR': 'symbol') : '0'}} </p>
                                    </div>
                                </div>

                                <div class="col-md-12 ">
                                    <div class="d-flex justify-content-around penaltyBill">
                                        <!-- <div class="text-center">
                                                    <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                                    <p class="font-size-18 font-weight-bold">
                                                        {{bills?.totalAmountwithoutpenalty!=undefined?(totalAmountwithoutpenalty
                                                        | currency: 'INR': 'symbol') : '0'}}</p>
                                                </div> -->
                                        <div class="text-center" *ngIf="bills.dueAmount>0">
                                            <p class="font-size-16 font-weight-bolder">Previous Month Due Amount
                                            </p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.dueAmount!=undefined?(bills.dueAmount
                                                | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Penalty Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{electricity?.penaltyAmount!=undefined?(electricity?.penaltyAmount
                                                | currency: 'INR': 'symbol') : '0'}} </p>
                                        </div>
                                        <div class="text-center">
                                            <p class="font-size-16 font-weight-bolder">Total Bill Amount</p>
                                            <p class="font-size-18 font-weight-bold">
                                                {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                                | currency: 'INR': 'symbol') : '0'}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <div (click)="onViewClick(billList[i])" style="cursor: pointer;">
                                    <p style="color: #2387C8;">Unpaid Bills View Details</p>
                                </div>
                            </div>
                        </accordion-group>
                        }

                        <!-- other Charges -->
                        @if(bills?.isOtherBill){
                        <accordion-group [isOpen]="isAllOpen" class="accordion-item mb-3 panel-open" #item8>
                            <div accordion-heading class="d-flex flex-grow-1">
                                <div class="d-flex pt-2 ">
                                    <div class="form-check  ">
                                        <input class="form-check-input"
                                            (click)="onCheckboxClick($event, bills?.isChecked, i, bills?.billNo)"
                                            (change)="checkValue(bills?.isChecked,i,bills?.billNo)"
                                            [disabled]="bills.isdisabled" [(ngModel)]="bills.isChecked" type="checkbox"
                                            id="formCheck1">
                                    </div>
                                </div>
                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                        <div class="flex-grow-1">
                                            <img class="utility-img" src="../../../../assets/images/brands/group.png">
                                            <span class="text-primary font-size-15">Other Charges: Billing Cart
                                                ({{bills?.billNo}})
                                            </span>
                                        </div>

                                    </div>
                                    <div>

                                        <div class="row mx-2 mt-3 text-accordian">
                                            <div class="col-lg-3  mb-3">
                                                <div class="mb-3">
                                                    <label class="form-label">Bill Date</label>
                                                    <p>{{bills?.billGeneratedDate!=null?
                                                        (bills?.billGeneratedDate | date:'d MMMM yyyy')
                                                        :'' }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-lg-3  mb-3">
                                                <div class="mb-3">
                                                    <label class="form-label">Due Date</label>
                                                    <p>{{bills.dueDate!=null?
                                                        (bills.dueDate | date:'d MMMM yyyy')
                                                        :'' }}
                                                    </p>
                                                </div>
                                            </div>
                                            <!-- <div class="col-lg-3  mb-3">
                                                <div class="mb-3">
                                                    <label class="form-label">Units Consumed (DG/EB)</label>
                                                    <p>{{ele?.noofElectricityUnitsConsumedEB?ele.noofElectricityUnitsConsumedDG:'-'}}/{{ele?.noofElectricityUnitsConsumedEB?ele.noofElectricityUnitsConsumedEB:'-'}}
                                                    </p>

                                                </div>
                                            </div> -->

                                            <div class="col-lg-3  mb-3">
                                                <div class="mb-3">
                                                    <label class="form-label">Sub Total</label>
                                                    <p>
                                                        {{bills?.billAmount!=undefined?(bills.billAmount
                                                        | currency: 'INR': 'symbol') : '0'}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="mdi font-size-24"
                                        [ngClass]="!item8?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex justify-content-center">
                                        <img src="../../../../assets/images/brands/utility.png" class="me-2 w-3">
                                        <p class="text-decoration-underline card-title font-size-15">Consumer
                                            Details
                                        </p>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/user.png"
                                                            class="w-80">
                                                    </div>

                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Consumer Name</label>
                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Flat No.</label>
                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-4  mb-3">
                                            <div class="mb-3">
                                                <div class="d-flex">
                                                    <div class="flex-shrink-0 me-1">
                                                        <img src="../../../../assets/images/brands/bill.png"
                                                            class="w-80">
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <label class="form-label">Bill No.</label>
                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <!--  -->
                            <div class="row custom-list-bill-view p-2 rounded mt-2">
                                <div class="col-lg-12">
                                    <div class="">
                                        <div class="row">
                                            <table class="table custom-border-table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Service Name</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">GST (%)</th>
                                                        <th scope="col">GST Amount</th>
                                                        <th scope="col">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let charge of bills?.generalCharges">
                                                        <td>{{charge.name}}</td>
                                                        <td>{{charge.amount}}</td>
                                                        <td>{{charge.gst !='' ?charge.gst : '-'}}</td>
                                                        <td>{{charge.gstAmt |currency:'INR':true}}</td>
                                                        <td>{{charge.total |currency:'INR':true}}</td>

                                                    </tr>
                                                    <tr>
                                                        <th scope="row"></th>
                                                        <td colspan="1"></td>
                                                        <td></td>
                                                        <td class="font-weight-bolder">Total Amount</td>
                                                        <td class="font-weight-bolder">
                                                            {{bills.totalGeneralCharge!=undefined?(bills.totalGeneralCharge
                                                            | currency: 'INR': 'symbol') : '0'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>


                                            <div class="col-md-12">
                                                <div class="text-center totalBill ">
                                                    <p class="mb-0 font-size-10 font-weight-bold ">Bill Amount :
                                                        {{bills.totalGeneralCharge!=undefined?(bills.totalGeneralCharge
                                                        | currency: 'INR': 'symbol') : '0'}} </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 ">
                                            <div class="d-flex justify-content-around penaltyBill">
                                                <div class="text-center">
                                                    <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                                    <p class="font-size-18 font-weight-bold">
                                                        {{bills?.totalGeneralCharge!=undefined?(bills.totalGeneralCharge
                                                        | currency: 'INR': 'symbol') : '0'}}</p>
                                                </div>
                                                <!-- <div class="text-center">
                                                    <p class="font-size-16 font-weight-bolder">Previous Month Due Amount
                                                    </p>
                                                    <p class="font-size-18 font-weight-bold">
                                                        {{bills?.dueAmount!=undefined?(bills.dueAmount
                                                        | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                                </div> -->
                                                <div class="text-center">
                                                    <p class="font-size-16 font-weight-bolder">Penalty Amount</p>
                                                    <p class="font-size-18 font-weight-bold">
                                                        {{bills?.gas[0]?.penaltyAmount!=undefined?(bills?.gas[0]?.penaltyAmount
                                                        | currency: 'INR': 'symbol') : '0'}} </p>
                                                </div>
                                                <div class="text-center">
                                                    <p class="font-size-16 font-weight-bolder">Total Bill Amount</p>
                                                    <p class="font-size-18 font-weight-bold">
                                                        {{bills?.totalBillAmount!=undefined?(bills.totalBillAmount
                                                        | currency: 'INR': 'symbol') : '0'}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </accordion-group>
                        }
                    </div>


                </accordion>
                }


            </div>

            <div class="col-lg-3">
                <div class="card bg-primary text-white-50">
                    <div class="card-body">
                        <h5 class="mt-0 text-white"> Cart Summary</h5>
                        <hr>
                        <div class="d-flex text-white justify-content-between mb-1">
                            <span>Bill Amount</span>
                            <span><span>{{paybillAmount?(paybillAmount
                                    | currency: 'INR': 'symbol') : '0'}}</span></span>
                        </div>
                        <hr>
                        <div class="d-flex text-white justify-content-between mb-1">
                            <span>Amount Payable</span>

                            <span>{{paybillAmount?(paybillAmount
                                | currency: 'INR': 'symbol') : '0'}}</span>
                        </div>

                        <button type="button" class="btn btn-white mb-2 mt-4" [disabled]="paybillAmount==0"
                            (click)="openPaymentDailog(paymentModel)">Pay
                            Bill</button>
                        <span></span>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="card-body">
        @if(billList && billList.length<1){ <div class="text-center">
            <!-- <img src="../../../assets/images/nodata.jpg" alt="" height="250"> -->
            <h4 class="mt-5">There are no pending bills</h4>
    </div>
    }




    <ng-template #paymentModel>
        <div class="modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-primary text-white">
                    <h5 class="modal-title">Pay Bill</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="paymentModal?.hide()"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="d-flex align-items-center">
                            <img src="../../../../assets/images/inr.svg" class="w-25">
                            <div class="align-items-center text-center flex-grow-1">
                                <h4>Amount Payable</h4>
                                <p>{{paybillAmount?(paybillAmount
                                    | currency: 'INR': 'symbol') : '0'}}</p>
                            </div>
                        </div>
                        <hr>

                        <!-- <div class="d-flex align-items-center justify-content-between">
                            <div class="col-lg-12 mb-3">
                                <input class="form-check-input" type="checkbox" id="formCheck1"
                                    [(ngModel)]="isAutoPayForBills">
                                <label class="form-check-label" for="formCheck1"> &nbsp; Would you like to enable Auto
                                    Pay? </label>

                            </div>


                        </div> -->


                        <div class="d-flex align-items-center justify-content-between" *ngIf="isWalletEnabled">
                            <p class="font-size-14 fw-bold mb-0">Wallet Balance:{{walletBalance?(walletBalance
                                | currency: 'INR': 'symbol') : '0'}}</p>


                            <button type="button" class="btn btn-primary waves-effect waves-light"
                                (click)="goToRecharge()" *ngIf="walletBalance < paybillAmount">recharge</button>
                            <button type="button" class="btn btn-primary waves-effect waves-light"
                                (click)="OnPaymentSuccess('',true)" *ngIf="walletBalance >= paybillAmount">pay from
                                wallet</button>&nbsp;&nbsp;
                            <span *ngIf="walletBalance < paybillAmount" class="text-danger">Insufficient
                                balance</span>


                            <!-- <button type="button"
                                    class="btn btn-primary btn-sm waves-effect waves-light">Recharge</button> -->

                        </div>


                        <div *ngIf="paybillAmount<=1" class="text-danger">Amount under Rs.1 should be paid using your
                            wallet
                        </div>
                        <p class="hr-center"><span>Or</span></p>

                    </div>
                </div>

            </div>
            <div class="modal-footer border-none">
                <button type="button" (click)="payNow(false)" [disabled]="paybillAmount<=1"
                    class="btn btn-primary waves-effect waves-light w-100">Pay
                    Online</button>

            </div>

        </div><!-- /.modal -->

    </ng-template>